(function(){
    'use strict'

    angular
    .module('app.impuestosRenta')
    .controller('ImpuestosRenta', ImpuestosRenta);

    ImpuestosRenta.$inject = ['$animationsSrv', 'ImpuestosRentaService', 'logger', '$location', 'UserInfoService'];

    function ImpuestosRenta($animationsSrv, ImpuestosRentaService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.impuestosRenta = [];
        vm.title = 'ImpuestosRenta';

        vm.goToEdit = function(impuestoRenta){
            
            var path = '/editar-impuesto-renta/';

            if(impuestoRenta){
                $location.path(path + impuestoRenta.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = ImpuestosRentaService.getAll();

            promise
            .then(function(impuestosRenta){
                vm.impuestosRenta = impuestosRenta;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los Impuestos de Renta.');
                        break;
                }
            });
        };

        vm.delete = function(impuestoRenta){
            var promise = ImpuestosRentaService.remove(impuestoRenta);
            
            promise
            .then(function(response){
                vm.impuestosRenta = vm.impuestosRenta.filter(function(g) {
                    return g.id !== impuestoRenta.id;
                });
                logger.success('Impuesto de Renta eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Impuesto de Renta');
                        break;
                }
                
            });   
        };

    }
})();